<template>
    <span class="br px-2 py-1" :class="[colorText, bkgColor]">
        <slot name="label"></slot>
    </span>
</template>

<script>
export default {
    props: {
        bgColor: {
            type: String,
            required: false,
            default: 'secondary-green'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        bkgColor() {
            return this.disabled ? 'gray-05-bkg' : `${this.bgColor}-bkg`;
        },
        colorText() {
            if(this.disabled) return 'gray-60';

            const bgColorNeedWhiteText = ['secondary-blue'];
            return bgColorNeedWhiteText.includes(this.bgColor) ? 'white' : 'secondary-blue';
        }
    }
}
</script>